import { render, staticRenderFns } from "./SettlementRunTab.vue?vue&type=template&id=9c671aa4"
import script from "./SettlementRunTab.vue?vue&type=script&lang=js"
export * from "./SettlementRunTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports